import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'button'];

  connect() {
    // Check localStorage for saved state
    const savedState = localStorage.getItem(this.element.dataset.collapseKey);
    if (savedState === 'collapsed') {
      this.collapse(false);
    }
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.contentTarget.classList.contains('hidden')) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  collapse(saveState = true) {
    this.contentTarget.classList.add('hidden');
    const chevron = this.buttonTarget.querySelector('svg');
    if (chevron) {
      chevron.classList.add('rotate-180');
    }
    if (saveState && this.element.dataset.collapseKey) {
      localStorage.setItem(this.element.dataset.collapseKey, 'collapsed');
    }
  }

  expand() {
    this.contentTarget.classList.remove('hidden');
    const chevron = this.buttonTarget.querySelector('svg');
    if (chevron) {
      chevron.classList.remove('rotate-180');
    }
    if (this.element.dataset.collapseKey) {
      localStorage.setItem(this.element.dataset.collapseKey, 'expanded');
    }
  }
}

